<template>
  <div class="confirmation" style="line-height: auto; background-color:#e6ecf1; margin:0 auto; padding:0!important; -webkit-text-size-adjust:100%; -ms-text-size-adjust:100%;-webkit-font-smoothing:antialiased;min-width:100%!important">
     
    <!-- error -->
    <div v-if="showError">
      <h5 v-if="showError" class="text-center p-3">{{ $t('confirmation.no_booking') }}.</h5>
    </div>

    <!-- content -->
    <table v-else-if="booking" class="table600" style="mso-table-lspace:0pt;mso-table-rspace:0pt;margin: 0 auto;" align="center" border="0" cellpadding="0" cellspacing="0" width="618">
      <tr>
        <td>
          <table class="table600Min" style="min-width:610px;mso-table-lspace:0;mso-table-rspace:0;border-radius:6px" align="left" border="0" cellpadding="0" cellspacing="0" width="610">
            <tr>
              <td style="min-width:610px" class="table600st" align="center">
                <table class="table608" style="mso-table-lspace:0pt;mso-table-rspace:0pt" border="0" cellpadding="0" cellspacing="0">
                  <tr>
                    <td align="center">
                      <table class="table600 page-break-avoid" style="mso-table-lspace:0pt;mso-table-rspace:0pt" border="0" cellpadding="0" cellspacing="0" width="610">
                        <tr>
                          <td class="wz" style="background-color:#FFFFFF;" width="30"></td>
                          <td class="proposalTD" style="color:#627189;font-family:sans-serif; background-color:#FFFFFF;">
                            <table style="border-collapse: collapse;">

                              <booking-intro :customer="booking.details.customer" />

                              <booking-parking-item 
                                v-for="(item, key) in booking.details.bookings.airportparking" 
                                :key="`ap-${key}-item`"
                                :item="item"
                                :airportparking="booking.details.bookings.airportparking.length"
                              />

                              <tr v-if="booking.details.bookings.airportparking.length > 0">
                                <td colspan="2" height="5" style="line-height:5px; font-size:0px;">
                                  <hr/>
                                </td>
                              </tr>

                              <booking-hotel-item 
                                v-for="(item, key) in booking.details.bookings.airporthotel" 
                                :key="`ah-${key}-item`"
                                :item="item"
                                :airporthotel="booking.details.bookings.airporthotel.length"
                              />

                              <tr v-if="booking.details.bookings.airporthotel.length > 0">
                                <td colspan="2" height="5" style="line-height:5px; font-size:0px;">
                                  <hr/>
                                </td>
                              </tr>

                              <booking-lounge-item 
                                v-for="(item, key) in booking.details.bookings.airportlounge" 
                                :key="`al-${key}-item`"
                                :item="item"
                                :airportlounge="booking.details.bookings.airportlounge.length"
                              />

                              <tr v-if="booking.details.bookings.airportlounge.length > 0">
                                <td colspan="2" height="5" style="line-height:5px; font-size:0px;">
                                  <hr/>
                                </td>
                              </tr>

                              <!-- sumamry -->
                              <booking-summary :booking="booking.details" />

                              <tr>
                                <td colspan="2" height="5" style="line-height:5px; font-size:0px;">
                                  <hr/>
                                </td>
                              </tr>

                              <!-- customer services -->
                              <booking-customer />

                              <tr>
                                <td colspan="2" height="5" style="line-height:5px; font-size:0px;">
                                  <hr/>
                                </td>
                              </tr>

                              <!-- terms -->
                              <booking-terms :website="website" :booking="booking" />
                              
                            </table>
                          </td>
                          <td class="wz" style="background-color:#FFFFFF;" width="30"></td>
                        </tr>
                      </table>

                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </td>
      </tr>
    </table>

    <!-- sticky for cancelled mode -->
    <div v-if="booking">
      <div v-for="(item, index) in booking.details.bookings.airportparking" :key="`ap-${index}`">
        <div class="sticky-note" v-if="item.booking.booking_mode === 'Cancelled'">
          <span v-if="cancel_date(item.booking.cancel_date)">*Your booking was cancelled on {{ cancel_date(item.booking.cancel_date) }}.</span> Refunds can take up to 3 to 10 days.
        </div>
      </div>
      <div v-for="(item, index) in booking.details.bookings.airportlounge" :key="`al-${index}`">
        <div class="sticky-note" v-if="item.booking.booking_mode === 'Cancelled'">
          <span v-if="cancel_date(item.booking.cancel_date)">*Your booking was cancelled on {{ cancel_date(item.booking.cancel_date) }}.</span> Refunds can take up to 3 to 10 days.
        </div>
      </div>
      <div v-for="(item, index) in booking.details.bookings.airporthotel" :key="`ah-${index}`">
        <div class="sticky-note" v-if="item.booking.booking_mode === 'Cancelled'">
          <span v-if="cancel_date(item.booking.cancel_date)">*Your booking was cancelled on {{ cancel_date(item.booking.cancel_date) }}.</span> Refunds can take up to 3 to 10 days.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { call, sync } from "vuex-pathify";
import { BookingIntro, BookingParkingItem, BookingHotelItem, BookingLoungeItem, BookingTerms, BookingSummary, BookingCustomer } from "@/components";
import mixins from "@/mixins";
import moment from "moment";

export default {
  name: 'confirmation-view',
  mixins: [mixins.pageview],
  components: { BookingIntro, BookingParkingItem, BookingHotelItem, BookingLoungeItem, BookingTerms, BookingSummary, BookingCustomer },
  computed: {
    booking: sync("payment/confirmation"),
  },
  data() {
    return {
      id: null,
      showError: false,
      color: "#0d6088",
      logo: 'https://cdn.maxemail.emailcenteruk.com/c1850/e546cf5139b1cb92d69a32512cbd9dc4.png',
      website: 'www.skyparksecure.com',
      print: false
    }
  },
  methods: {
    getBooking: call("payment/confirmation"),
    cancel_date(value) {
      return moment(value).isValid() && moment(value).isAfter('2020') ? moment(value).format('Do MMM YYYY, HH:mm') : false;
    },
  },
  mounted() {
    this.booking = null;
    this.id = this.$route.query.id;

    this.sendPageView();

    if(this.id) {
      this.getBooking(this.id).then(() => {
        if(!this.booking) return this.showError = true;

        if(this.$route.query.print && typeof window.print === "function") {
          setTimeout(() => window.print(), 100)
        }
      })
    } else {
      this.showError = true;
    }
  }
}
</script>

<style>
.confirmation td, 
.confirmation tr {
  line-height: initial;
}
@media print {
  .vld-overlay {
    display: none;
  }
}
</style>